import { AppBar, Box, Button, Container, Toolbar, Typography, Avatar, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, Drawer, Card, CardMedia, Dialog, DialogContent, DialogActions, MenuItem, Menu, IconButton, Collapse, Tooltip } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { useDataContext } from '../contexts/dataContext';
import AvisosEntidad from './configuracion/AvisosEntidad';
import PriceChangeTwoToneIcon from '@mui/icons-material/PriceChangeTwoTone';
import FlakyTwoToneIcon from '@mui/icons-material/FlakyTwoTone';
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import PaidTwoToneIcon from '@mui/icons-material/PaidTwoTone';
import StyleTwoToneIcon from '@mui/icons-material/StyleTwoTone';
import FeedbackTwoToneIcon from '@mui/icons-material/FeedbackTwoTone';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import AddTaskTwoToneIcon from '@mui/icons-material/AddTaskTwoTone';
import PriceCheckTwoToneIcon from '@mui/icons-material/PriceCheckTwoTone';
import CalculateTwoTone from '@mui/icons-material/CalculateTwoTone';
import FolderCopyTwoToneIcon from '@mui/icons-material/FolderCopyTwoTone';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import HouseTwoToneIcon from '@mui/icons-material/HouseTwoTone';

export default function Navegacion() {
    const { usuario, esAsistente, setEsAsistente, esJefe, setEsJefe, setUsuario, esJefeCaja, setEsJefeCaja,/*planPresupuestalContexto,*/ openAvisos, setOpenAvisos } = useDataContext()

    const [state, setState] = useState({
        left: false,
    });

    const [anchorElNav, setAnchorElNav] = useState(null);
    const [openGestion, setOpenGestion] = useState(true);
    const [openGestionAnterior, setOpenGestionAnterior] = useState(false);
    const [fase, setFase] = useState(null)

    const handleClickGestion = (event) => {
        event.stopPropagation();
        setOpenGestion(!openGestion);
    };

    const handleClickGestionAnterior = (event) => {
        event.stopPropagation();
        setOpenGestionAnterior(!openGestionAnterior);
    };

    const token = sessionStorage.getItem('token')
    let idResponsable = null
    let idEntidad = null
    let idEntidadSuperior = null

    if (token) {
        const decoded = jwt_decode(token);
        idResponsable = decoded.id
        idEntidad = sessionStorage.getItem('idEntidad')
        idEntidadSuperior = sessionStorage.getItem('idEntidadSuperior')

    }
    const obtenerReglas = (decoded) => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }
    useEffect(() => {
        (async () => {
            if (token) {
                const decoded = jwt_decode(token);
                let reglas = decoded.rules
                if (!reglas)
                    reglas = obtenerReglas(decoded)
                const idResponsable = decoded.id;
                const resUsuario = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/${idResponsable}`)
                const data = await resUsuario.json()
                setUsuario(data)
                let resEstado
                if (sessionStorage.getItem('idPlan') === null) {
                    resEstado = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/leerActualEntidad/${sessionStorage.getItem('idEntidad')}`)

                }
                else {
                    resEstado = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/leerEstado/${sessionStorage.getItem('idPlan')}`)
                }
                const plan = await resEstado.json()
                setFase(plan.fase)
                //console.log(plan.fase)
                for (let i = 0; i < reglas.length; i++) {
                    //console.log(`REGLA ${i} action ${reglas[i].action} subject ${reglas[i].subject}`)
                    if (reglas[i].action === 'manage' && reglas[i].subject === 'planPresupuestal') {
                        setEsJefe(true)
                        return
                    }
                    if (reglas[i].action === 'asistente' && reglas[i].subject === 'division') {
                        setEsAsistente(true)
                        return
                    }
                    if (reglas[i].action === 'jefatura' && reglas[i].subject === 'caja') {
                        setEsJefeCaja(true)
                        return
                    }
                }
            }

        })();
    }, []);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleClose = () => {
        setOpenAvisos(false);
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItem key={'logo'} disablePadding>
                    <ListItemButton>
                        <Card>
                            <CardMedia
                                component="img"
                                image="/images/nadu.png"
                                alt="Nadu"
                                style={{ objectFit: 'contain' }}
                            />
                        </Card>
                    </ListItemButton>
                </ListItem>

            </List>
            <Divider />
            {esJefeCaja ? <List>
                {([{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon> }, { text: `Seguimiento de solicitudes`, url: `/seguimientoSolicitudes/tipoCaja`, icon: <FlakyTwoToneIcon></FlakyTwoToneIcon> },]).map((value, index) => (
                    <ListItem key={value.text} disablePadding>
                        <ListItemButton onClick={() => {
                            if (value.url === 'menu') {
                                window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`)
                                return
                            }
                            else
                                navigate(value.url);
                            // if (value.url.includes('/true') || value.url.includes('/false'))
                            window.location.reload();

                        }}>
                            <ListItemIcon>
                                {value.icon}
                            </ListItemIcon>
                            <ListItemText primary={value.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List> : <></>}
            {esJefe ?
                <>
                    {/* DESCOMENTAR PARA PLANEACIÓN SIGUIENTE AÑO <>
                    <ListItemButton onClick={handleClick}>
                        <ListItemText primary={`Planeación ${Number((new Date()).getFullYear()) + 1}`} primaryTypographyProps={{ fontWeight: 500, letterSpacing: '2px' }} />
                        {openPlaneacion ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    
                    <Collapse in={openPlaneacion} timeout="auto" unmountOnExit sx={{ pl: 1 }}>
                        <List>
                            {(!isNaN(Number(sessionStorage.getItem('idPlan'))) ? [{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon> }, { text: 'Nueva Planeación Presupuestal', url: `/true`, icon: <PriceChangeTwoToneIcon></PriceChangeTwoToneIcon> }, { text: 'Elaboración de Informe por Proyecto', url: `/proyectosInforme/${idResponsable}/true`, icon: <FolderCopyTwoToneIcon></FolderCopyTwoToneIcon> }
                            //, { text: 'Avance presupuestal', url: !isNaN(Number(sessionStorage.getItem('idEntidadSuperior'))) ? `/proyectosEntidad/${sessionStorage.getItem('idPlan')}` : `/seguimientoSolicitudes/planeacion/${idResponsable}/${idEntidad}`, icon: <CalculateTwoTone></CalculateTwoTone> }
                        ]
                                : [{ text: 'Nueva Planeación Presupuestal', url: `/true`, icon: <PriceChangeTwoToneIcon></PriceChangeTwoToneIcon> }, { text: 'Elaboración de Informe por Proyecto', url: `/proyectosInforme/${idResponsable}/true`, icon: <FolderCopyTwoToneIcon></FolderCopyTwoToneIcon> }]).map((value, index) => (
                                    <ListItem key={value.text} disablePadding>
                                        <ListItemButton>
                                            <ListItemIcon>
                                                {value.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={value.text} onClick={() => {
                                                if(value.url === 'menu'){ 
                                                   window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`) 
                                                   return
                                                }
                                                else
                                                   navigate(value.url);
                                                if (value.url.includes('/true') || value.url.includes('/false'))
                                                    window.location.reload();

                                            }} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                        </List>
                    </Collapse>
                    </>*/
                    }
                    <ListItemButton onClick={handleClickGestion}>
                        <ListItemText primary={`Gestión ${Number((new Date()).getFullYear())}`} primaryTypographyProps={{ fontWeight: 500, letterSpacing: '2px' }} />
                        {openGestion ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openGestion} timeout="auto" unmountOnExit sx={{ pl: 1 }}>
                        <List>
                            {([{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon>, disabled: false }, { text: 'Plan Presupuestal', url: `/false`, icon: <PriceCheckTwoToneIcon></PriceCheckTwoToneIcon>, disabled: false }, { text: 'Informe por Proyecto', url: `/proyectosInforme/${idResponsable}/false`, icon: <FolderCopyTwoToneIcon></FolderCopyTwoToneIcon>, disabled: false }, { text: 'Seguimiento de mis solicitudes', url: `/seguimientoSolicitudes/porResponsable/${sessionStorage.getItem('idTitularPerfil') ? sessionStorage.getItem('idTitularPerfil') : idResponsable}`, icon: <AddTaskTwoToneIcon></AddTaskTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: `Seguimiento de solicitudes como titular `, url: `/seguimientoSolicitudes/porPlan/${sessionStorage.getItem('idPlan')}`, icon: <FlakyTwoToneIcon></FlakyTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: `Solicitar Servicio`, url: `/servicios/${idResponsable}`, icon: <QuestionAnswerTwoToneIcon></QuestionAnswerTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: 'Configuración de avisos', url: '/avisos', icon: <FeedbackTwoToneIcon></FeedbackTwoToneIcon>, disabled: false }/*, { text: 'Catálogo de Proveedores', url: '/proveedores', icon: <AssignmentIndTwoToneIcon></AssignmentIndTwoToneIcon>, disabled: false }*/]).map((value, index) => (
                                <ListItem key={value.text} disablePadding>
                                    <Tooltip placement="right" title={value.disabled ? 'Se activa cuando se hayan capturado todos los informes y el titular(Jefatura de depto., Dirección, Coordinación, etc.) ponga la planeación en APROBADA POR CONSEJO' : ''} arrow>
                                        <span>
                                            <ListItemButton disabled={value.disabled} onClick={() => {
                                                if (value.url === 'menu') {
                                                    window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`)
                                                    return
                                                }
                                                else
                                                    navigate(value.url);
                                                // if (value.url.includes('/true') || value.url.includes('/false'))
                                                window.location.reload();

                                            }}>
                                                <ListItemIcon>
                                                    {value.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={value.text} />
                                            </ListItemButton>
                                        </span>
                                    </Tooltip>
                                </ListItem>

                            ))}
                            {Number(idEntidad) === 1 || Number(idEntidad) === 2 || Number(idEntidadSuperior) === 1 || Number(idEntidadSuperior) === 2 ?
                                <>
                                    <ListItem key={'Consulta de saldos'} disablePadding>
                                        <ListItemButton onClick={() => { navigate('/saldo/saldosListado') }}>
                                            <ListItemIcon>
                                                <PriceChangeTwoToneIcon></PriceChangeTwoToneIcon>
                                            </ListItemIcon>
                                            <ListItemText primary={'Consulta de saldos'} />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem key={'Consulta de trámites'} disablePadding>
                                        <ListItemButton onClick={() => { navigate('/tramites/tramitesListado') }}>
                                            <ListItemIcon>
                                                <PriceChangeTwoToneIcon></PriceChangeTwoToneIcon>
                                            </ListItemIcon>
                                            <ListItemText primary={'Consulta de trámites'} />
                                        </ListItemButton>
                                    </ListItem>
                                </> : <ListItem key={'Avance presupuestal'} disablePadding>
                                    <ListItemButton onClick={() => { navigate(!isNaN(Number(sessionStorage.getItem('idEntidadSuperior'))) ? `/proyectosEntidad/${sessionStorage.getItem('idPlan')}` : `/seguimientoSolicitudes/planeacion/${idResponsable}/${idEntidad}`) }}>
                                        <ListItemIcon>
                                            <CalculateTwoTone></CalculateTwoTone>
                                        </ListItemIcon>
                                        <ListItemText primary={'Avance presupuestal'} />
                                    </ListItemButton>
                                </ListItem>

                            }
                        </List>
                    </Collapse>
                    {
                        !isNaN(sessionStorage.getItem('idPlanAnterior')) ?
                            <>
                                <ListItemButton onClick={handleClickGestionAnterior}>
                                    <ListItemText primary={`${Number((new Date()).getFullYear()) - 1}`} primaryTypographyProps={{ fontWeight: 500, letterSpacing: '2px' }} />
                                    {openGestionAnterior ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                                <Collapse in={openGestionAnterior} timeout="auto" unmountOnExit sx={{ pl: 1 }}>
                                    <List>
                                        {(!isNaN(Number(sessionStorage.getItem('idPlanAnterior'))) ? [{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon> }, { text: 'Plan Presupuestal', url: `/${Number((new Date()).getFullYear()) - 1}`, icon: <PriceCheckTwoToneIcon></PriceCheckTwoToneIcon> }, { text: 'Informe por Proyecto', url: `/proyectosInforme/${idResponsable}/${Number((new Date()).getFullYear()) - 1}`, icon: <FolderCopyTwoToneIcon></FolderCopyTwoToneIcon> }, { text: 'Seguimiento de solicitudes como titular', url: `/seguimientoSolicitudes/porPlan/${sessionStorage.getItem('idPlanAnterior')}`, icon: <FlakyTwoToneIcon></FlakyTwoToneIcon> }]
                                            : [{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon>, disabled: false }, { text: 'Plan Presupuestal', url: `/false`, icon: <PriceCheckTwoToneIcon></PriceCheckTwoToneIcon>, disabled: false }, { text: 'Informe por Proyecto', url: `/proyectosInforme/${idResponsable}/false`, icon: <FolderCopyTwoToneIcon></FolderCopyTwoToneIcon>, disabled: false }, { text: 'Seguimiento de mis solicitudes', url: `/seguimientoSolicitudes/porResponsable/${sessionStorage.getItem('idTitularPerfil') ? sessionStorage.getItem('idTitularPerfil') : idResponsable}`, icon: <AddTaskTwoToneIcon></AddTaskTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: 'Seguimiento de solicitudes como titular', url: `/seguimientoSolicitudes/porPlan/${sessionStorage.getItem('idPlan')}`, icon: <FlakyTwoToneIcon></FlakyTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: `Solicitar Servicio`, url: `/servicios/${idResponsable}`, icon: <QuestionAnswerTwoToneIcon></QuestionAnswerTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: 'Configuración de avisos', url: '/avisos', icon: <FeedbackTwoToneIcon></FeedbackTwoToneIcon>, disabled: false }/*, { text: 'Catálogo de Proveedores', url: '/proveedores', icon: <AssignmentIndTwoToneIcon></AssignmentIndTwoToneIcon>, disabled: false }*/]).map((value, index) => (
                                                <ListItem key={value.text} disablePadding>
                                                    <Tooltip placement="right" title={value.disabled ? 'Se activa cuando se hayan capturado todos los informes y el titular (Jefatura de depto., Dirección, Coordinación, etc.) ponga la planeación en APROBADA POR CONSEJO' : ''} arrow>
                                                        <span>
                                                            <ListItemButton disabled={value.disabled} onClick={() => {
                                                                if (value.url === 'menu') {
                                                                    window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`)
                                                                    return
                                                                }
                                                                else
                                                                    navigate(value.url);
                                                                // if (value.url.includes('/true') || value.url.includes('/false'))
                                                                window.location.reload();

                                                            }}>
                                                                <ListItemIcon>
                                                                    {value.icon}
                                                                </ListItemIcon>
                                                                <ListItemText primary={value.text} />
                                                            </ListItemButton>
                                                        </span>
                                                    </Tooltip>
                                                </ListItem>
                                            ))}
                                    </List>
                                </Collapse>
                            </> : <></>
                    }

                </>
                : <></>
            }
            {!esJefe && !esAsistente && !esJefeCaja ?
                <>
                    {/* DESCOMENTAR PARA PLANEACUIÓN SIGUIENTE AÑO<>
                        <ListItemButton onClick={handleClick}>
                            <ListItemText primary={`Planeación ${Number((new Date()).getFullYear()) + 1}`} primaryTypographyProps={{ fontWeight: 500, letterSpacing: '2px' }} />
                            {openPlaneacion ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openPlaneacion} timeout="auto" unmountOnExit sx={{ pl: 1 }}>
                            <List>
                                {[{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon> }, { text: 'Elaboración de Informe por Proyecto', url: `/proyectosInforme/${idResponsable}/true`, icon: <FolderCopyTwoToneIcon></FolderCopyTwoToneIcon> }, { text: 'Catálogo de Proveedores', url: '/proveedores', icon: <AssignmentIndTwoToneIcon></AssignmentIndTwoToneIcon> }].map((value, index) => (
                                    <ListItem key={value.text} disablePadding>
                                        <ListItemButton onClick={() => {
                                            if (value.url === 'menu') {
                                                window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`)
                                                return
                                            }
                                            else
                                                navigate(value.url);
                                            if (value.url.includes('/true') || value.url.includes('/false'))
                                                window.location.reload();

                                        }}>
                                            <ListItemIcon>
                                                {value.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={value.text} />

                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </>*/}
                    <ListItemButton onClick={handleClickGestion}>
                        <ListItemText primary={`Gestión ${Number((new Date()).getFullYear())}`} primaryTypographyProps={{ fontWeight: 500, letterSpacing: '2px' }} />
                        {openGestion ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openGestion} timeout="auto" unmountOnExit sx={{ pl: 1 }}>
                        <List>
                            {[{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon>, disabled: false }, { text: 'Gestión Presupuestal', url: `/proyectosGestion/${idResponsable}`, icon: <PriceCheckTwoToneIcon></PriceCheckTwoToneIcon>, disabled: false }, { text: 'Seguimiento de solicitudes', url: `/seguimientoSolicitudes/porResponsable/${idResponsable}`, icon: <AddTaskTwoToneIcon></AddTaskTwoToneIcon>, disabled: Number(fase) !== Number(3) }, { text: `Solicitar Servicio`, url: `/servicios/${idResponsable}`, icon: <QuestionAnswerTwoToneIcon></QuestionAnswerTwoToneIcon>, disabled: Number(fase) !== Number(3) }/*, { text: 'Catálogo de Proveedores', url: '/proveedores', icon: <AssignmentIndTwoToneIcon></AssignmentIndTwoToneIcon>, disabled: false }*/].map((value, index) => (
                                <ListItem key={value.text} disablePadding>
                                    <Tooltip placement="right" title={value.disabled ? 'Se activa cuando se hayan capturado todos los informes y el titular (Jefatura de depto., Dirección, Coordinación, etc.) ponga la planeación en APROBADA POR CONSEJO' : ''} arrow>
                                        <span>
                                            <ListItemButton disabled={value.disabled} onClick={() => {
                                                if (value.url === 'menu') {
                                                    window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`)
                                                    return
                                                }
                                                else
                                                    navigate(value.url);
                                                if (value.url.includes('/true') || value.url.includes('/false'))
                                                    window.location.reload();

                                            }}>
                                                <ListItemIcon>
                                                    {value.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={value.text} />
                                            </ListItemButton>
                                        </span>
                                    </Tooltip>
                                </ListItem>
                            ))}
                        </List>
                    </Collapse>
                </> : <></>
            }

            <Divider />
            {esAsistente ? <List>
                {[{ text: 'Menú aplicaciones', url: `menu`, icon: <HouseTwoToneIcon></HouseTwoToneIcon> }, { text: 'Seguimiento de solicitudes', url: `/seguimientoSolicitudes/division/${usuario ? usuario.id : 0}`, icon: <FlakyTwoToneIcon></FlakyTwoToneIcon> }, { text: 'Configuración de Fechas', url: `/configuracionFechas/${idEntidad}`, icon: <EventTwoToneIcon></EventTwoToneIcon> }, { text: 'Configuración de Montos', url: `/configuracionMontos/${idEntidad}`, icon: <PaidTwoToneIcon></PaidTwoToneIcon> }, { text: 'Catálogo de Partidas', url: '/partidas', icon: <StyleTwoToneIcon></StyleTwoToneIcon> }, { text: 'Configuración de avisos', url: '/avisos', icon: <FeedbackTwoToneIcon></FeedbackTwoToneIcon> }/*, { text: 'Catálogo de Proveedores', url: '/proveedores', icon: <AssignmentIndTwoToneIcon></AssignmentIndTwoToneIcon> }*/].map((value, index) => (
                    <ListItem key={value.text} disablePadding>
                        <ListItemButton onClick={() => { value.url === 'menu' ? window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/`) : navigate(value.url) }}>
                            <ListItemIcon>
                                {value.icon}
                            </ListItemIcon>
                            <ListItemText primary={value.text} />
                        </ListItemButton>
                    </ListItem>
                ))
                }
                {Number(idEntidad) === 1 || Number(idEntidad) === 2 ?
                    <>
                        <ListItem key={'Consulta de saldos'} disablePadding>
                            <ListItemButton onClick={() => { navigate('/saldo/saldosListado') }}>
                                <ListItemIcon>
                                    <PriceChangeTwoToneIcon></PriceChangeTwoToneIcon>
                                </ListItemIcon>
                                <ListItemText primary={'Consulta de saldos'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={'Consulta de trámites'} disablePadding>
                            <ListItemButton onClick={() => { navigate('/tramites/tramitesListado') }}>
                                <ListItemIcon>
                                    <PriceChangeTwoToneIcon></PriceChangeTwoToneIcon>
                                </ListItemIcon>
                                <ListItemText primary={'Consulta de trámites'} />
                            </ListItemButton>
                        </ListItem></> : <></>

                }
            </List>
                : <></>}

        </Box>
    );

    const navigate = useNavigate()

    return (
        <>
            <Box style={{ flexGrow: 1 }}>
                <AppBar position='sticky' color='primary' >
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <Typography variant='h5' style={{ flexGrow: 1 }}>
                                Gestión presupuestal
                            </Typography>
                            {token ?
                                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                        sx={{
                                            display: { xs: 'block', md: 'none' },
                                        }}
                                    >

                                        <MenuItem key={'menu'} onClick={handleCloseNavMenu}>
                                            {['left'].map((anchor) => (
                                                <Fragment key={anchor}>
                                                    <Button variant='outlined' color='inherit' style={{ marginRight: 5, width: '100%' }} onClick={toggleDrawer(anchor, true)}>Menu</Button>
                                                    <Drawer
                                                        anchor={anchor}
                                                        open={state[anchor]}
                                                        onClose={toggleDrawer(anchor, false)}
                                                    >
                                                        {list(anchor)}
                                                    </Drawer>
                                                </Fragment>
                                            ))}
                                        </MenuItem>
                                        {/*<MenuItem key={'manual'} onClick={handleCloseNavMenu}>
                                            <Button variant='outlined' color='inherit' onClick={() => { window.open("http://sites.ler.uam.mx/es/UAML/manualesNadu2") }} style={{ display: (token ? 'block' : 'none'), width: '100%' }}>Manuales</Button>
                                        </MenuItem>*/}
                                        <MenuItem key={'video'} onClick={handleCloseNavMenu}>
                                            <Button variant='outlined' color='inherit' onClick={() => { navigate("/videos") }} style={{ display: (token ? 'block' : 'none'), width: '100%' }}>Vídeos</Button>
                                        </MenuItem>
                                        <MenuItem key={'logout'} onClick={handleCloseNavMenu}>
                                            {token ? (
                                                <Button variant='outlined' color='inherit' onClick={() => { sessionStorage.clear(); setEsAsistente(false); setEsJefe(false); window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/logout`) }} style={{ display: (token ? 'block' : 'none'), width: '100%' }}>Cerrar sesión</Button>) : (<></>)}
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                : <></>}
                            <Box sx={{ flexGrow: 'revert', display: { xs: 'none', md: 'flex' } }}>
                                {token ? <>
                                    <Fragment key={'left'}>
                                        <Button variant='outlined' color='inherit' style={{ marginRight: 5 }} onClick={toggleDrawer('left', true)}>Menu</Button>
                                        <Drawer
                                            anchor={'left'}
                                            open={state['left']}
                                            onClose={toggleDrawer('left', false)}
                                        >
                                            {list('left')}
                                        </Drawer>
                                    </Fragment>


                                    {/*<Button variant='outlined' color='inherit' onClick={() => { window.open("http://sites.ler.uam.mx/es/UAML/manualesNadu2") }} style={{ display: (token ? 'block' : 'none') }}>Manuales</Button>*/}

                                    <Button variant='outlined' color='inherit' onClick={() => { navigate("/videos") }} style={{ display: (token ? 'block' : 'none') }}>Vídeos</Button>
                                    <Button variant='outlined' color='inherit' onClick={() => { navigate("/manuales") }} style={{ display: (token ? 'block' : 'none') }}>Manuales</Button>

                                    <Button variant='outlined' color='inherit' onClick={() => { sessionStorage.clear(); setEsAsistente(false); setEsJefe(false); window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/logout`) }} style={{ display: (token ? 'block' : 'none'), marginRight: 20 }}>Cerrar sesión</Button>
                                </> : <></>
                                }
                            </Box>

                            <Avatar alt="UAM-L" src="/images/UAML.png" />
                        </Toolbar>
                    </Container>
                </AppBar>
            </Box>
            <Dialog open={openAvisos} fullWidth={true}
                maxWidth='xl' >

                <DialogContent style={{ backgroundColor: '#FFFEED' }}>
                    {token ?
                        <AvisosEntidad></AvisosEntidad>
                        : <></>
                    }
                </DialogContent>
                <DialogActions style={{ backgroundColor: '#FFFEED' }}>
                    <Button onClick={handleClose}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}